import Navbar from "./Navbar";
import { datadogLogs } from "@datadog/browser-logs";
import Footer from "common/src/components/Footer";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AccessDenied() {
  datadogLogs.logger.info(`====> Route: NotFound`);
  datadogLogs.logger.info(`====> URL: ${window.location.href}`);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Navbar, {}), /*#__PURE__*/_jsxs("div", {
      className: "lg:mx-20 h-screen px-4 py-7",
      children: [/*#__PURE__*/_jsx("main", {
        className: "h-screen",
        children: /*#__PURE__*/_jsx("div", {
          className: "flex pt-8",
          children: /*#__PURE__*/_jsxs("div", {
            className: "m-auto text-center mt-5",
            children: [/*#__PURE__*/_jsx("h1", {
              className: "my-5 text-sm text-red-100 font-bold",
              children: "ERROR"
            }), /*#__PURE__*/_jsx("h2", {
              className: "my-5 text-4xl",
              children: "Access Denied!"
            }), /*#__PURE__*/_jsx("p", {
              className: "text-grey-400 mb-5",
              children: "It looks like you don't have access to this page.."
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Footer, {})]
    })]
  });
}